var translationKey = 'faqs.description';
var athome = {
    drawerActionButton: null,
    certificateBalance: true,
    certificateExpirationDays: 90,
    certificateValue: 5,
    disclaimerTranslationKey: 'athomeDisclaimer',
    es: {
        termsAndConditionsLink: 'https://www.synchronycredit.com/essimages/cs/groups/ess_webasset/plcc/@athome/en/html/ess014707.html'
    },
    en: {
        termsAndConditionsLink: 'https://www.synchronycredit.com/essimages/cs/groups/ess_webasset/plcc/@athome/en/html/ess014707.html'
    },
    howToEarnPointsHeader: 'fullDetailsPage.howToEarnPointsHeader',
    faqsSnapshot: true,
    isRewardTiers: false,
    isValuePropBanner: true,
    links: [
        {
            href: 'https://www.athome.com/',
            text: 'athome.com'
        }
    ],
    translationViewPrintKey: null,
    DUAL_CARD: {
        actionButton: null,
        banner: 'athome-banner-DC-md.png',
        bannerSm: 'athome-banner-DC-sm.png',
        cashRewardsBalance: false,
        certificateHistoryImg: 'athome-banner-DC-md.png',
        certificateHistoryImgSm: 'athome-banner-DC-sm.png',
        certificateHistory: true,
        faqs: null,
        rewardsBalance: true,
        snapshotTranslationKey: translationKey,
        translationKey: translationKey,
        valuePropImg: 'athome-valuePropDualCard.png',
        en: {
            propositions: [
                {
                    description: 'Earn 5% back in Rewards Points on At Home purchases.*',
                    heading: 'earn',
                    points: '5% back'
                },
                {
                    description: 'Earn 3% back in Rewards Points everywhere else Mastercard is accepted.*',
                    heading: 'earn',
                    points: '3% back'
                }
            ]
        },
        es: {
            propositions: [
                {
                    description: 'Obtenga 5% de reembolso en puntos de Recompensas en compras realizadas en At Home.*',
                    heading: 'obtenga',
                    points: '5% de reembolso'
                },
                {
                    description: 'Obtenga 3% de reembolso en Puntos de Recompensas en cualquier lugar que acepte la tarjeta Mastercard.*',
                    heading: 'obtenga',
                    points: '3% de reembolso'
                }
            ]
        }
    },
    PRIVATE_LABEL: {
        actionButton: null,
        banner: 'athome-banner-PLCC-md.png',
        bannerSm: 'athome-banner-PLCC-sm.png',
        cashRewardsBalance: false,
        certificateHistoryImg: 'athome-banner-PLCC-md.png',
        certificateHistoryImgSm: 'athome-banner-PLCC-sm.png',
        certificateHistory: true,
        faqs: null,
        rewardsBalance: true,
        snapshotTranslationKey: translationKey,
        translationKey: translationKey,
        valuePropImg: 'athome-valuePropPrivateLabel-md.png',
        en: {
            propositions: [
                {
                    description: 'Earn 5% back in Rewards Points on At Home purchases.*',
                    heading: 'earn',
                    points: '5% back'
                }
            ]
        },
        es: {
            propositions: [
                {
                    description: 'Obtenga 5% de reembolso en puntos de Recompensas en compras realizadas en At Home.*',
                    heading: 'obtenga',
                    points: '5% de reembolso'
                }
            ]
        }
    }
};
export default athome;
